var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-1",
    attrs: {
      "max-width": "1140px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("기본정보")]), _c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-card-text', [_c('v-row', {
    staticClass: "ma-n2"
  }, [_vm.isRoot ? _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "mt-2 mb-n2 mx-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.lawyer.image ? _c('v-img', {
    attrs: {
      "max-width": "48",
      "max-height": "48",
      "src": _vm.createObjectURL(_vm.lawyer.image),
      "contain": ""
    }
  }) : _c('v-responsive', {
    staticClass: "grey lighten-2",
    attrs: {
      "width": "48",
      "height": "48"
    }
  }, [_c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2"
  }, [_c('v-file-input', {
    staticClass: "ma-0",
    attrs: {
      "label": "변호사 이미지",
      "persistent-placeholder": "",
      "show-size": "",
      "accept": "image/*"
    },
    model: {
      value: _vm.lawyer.image,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer, "image", $$v);
      },
      expression: "lawyer.image"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1)], 1)], 1) : _vm._e(), _vm.isRoot ? _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "코드",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lawyer.code,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer, "code", $$v);
      },
      expression: "lawyer.code"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "언어",
      "items": ['ko', 'en'],
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lawyer.local,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer, "local", $$v);
      },
      expression: "lawyer.local"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "노출순서",
      "persistent-placeholder": "",
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: _vm.lawyer.index,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer, "index", $$v);
      },
      expression: "lawyer.index"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이름",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lawyer.name,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer, "name", $$v);
      },
      expression: "lawyer.name"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "직급",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lawyer.rank,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer, "rank", $$v);
      },
      expression: "lawyer.rank"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "전화번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lawyer.phone,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer, "phone", $$v);
      },
      expression: "lawyer.phone"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이메일",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lawyer.email,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer, "email", $$v);
      },
      expression: "lawyer.email"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("간단 소개")]), _c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lawyer.about,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer, "about", $$v);
      },
      expression: "lawyer.about"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("소개")]), _c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lawyer.section1.txt,
      callback: function ($$v) {
        _vm.$set(_vm.lawyer.section1, "txt", $$v);
      },
      expression: "lawyer.section1.txt"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("업무분야")]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }), _c('v-col'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "elevation": "4"
    },
    on: {
      "click": _vm.setItem
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("항목 추가")], 1), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "red",
      "elevation": "4",
      "outlined": ""
    },
    on: {
      "click": _vm.deleteItem
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-delete-outline")]), _vm._v("항목 삭제")], 1)], 1)], 1), _vm._l(_vm.lawyer.section2, function (section2, index) {
    return _c('div', {
      key: index
    }, [_c('v-divider'), _c('v-card-text', {
      staticClass: "py-0"
    }, [[_c('v-row', {
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: section2.title,
        callback: function ($$v) {
          _vm.$set(section2, "title", $$v);
        },
        expression: "section2.title"
      }
    })], 1), _c('v-col', _vm._l(section2.columns, function (column, index) {
      return _c('v-col', {
        key: index
      }, [_c('v-textarea', {
        attrs: {
          "rows": "1",
          "dense": "",
          "outlined": "",
          "hide-details": ""
        },
        model: {
          value: column.txt,
          callback: function ($$v) {
            _vm.$set(column, "txt", $$v);
          },
          expression: "column.txt"
        }
      })], 1);
    }), 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-col', [_c('v-btn', {
      attrs: {
        "small": "",
        "color": "primary",
        "elevation": "4"
      },
      on: {
        "click": function ($event) {
          return _vm.setColumn(index);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "16"
      }
    }, [_vm._v("mdi-plus")]), _vm._v("행 추가")], 1)], 1), _c('v-col', [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteColumn(index);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "16"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("행 삭제")], 1)], 1)], 1)], 1)]], 2)], 1);
  })], 2)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("학력사항")]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }), _c('v-col'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "elevation": "4"
    },
    on: {
      "click": _vm.setSection3Column
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("항목 추가")], 1), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "red",
      "elevation": "4",
      "outlined": ""
    },
    on: {
      "click": _vm.deleteSection3Column
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-delete-outline")]), _vm._v("항목 삭제")], 1)], 1)], 1), _c('div', [_c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_vm._l(_vm.lawyer.section3, function (section3, index) {
    return _c('v-row', {
      key: index,
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: section3.title,
        callback: function ($$v) {
          _vm.$set(section3, "title", $$v);
        },
        expression: "section3.title"
      }
    })], 1), _c('v-col', [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: section3.txt,
        callback: function ($$v) {
          _vm.$set(section3, "txt", $$v);
        },
        expression: "section3.txt"
      }
    })], 1)], 1);
  })], 2)], 1)], 1)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("경력사항")]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }), _c('v-col'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "elevation": "4"
    },
    on: {
      "click": _vm.setSection4Column
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("항목 추가")], 1), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "red",
      "elevation": "4",
      "outlined": ""
    },
    on: {
      "click": _vm.deleteSection4Column
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-delete-outline")]), _vm._v("항목 삭제")], 1)], 1)], 1), _c('div', [_c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_vm._l(_vm.lawyer.section4, function (section4, index) {
    return _c('v-row', {
      key: index,
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: section4.title,
        callback: function ($$v) {
          _vm.$set(section4, "title", $$v);
        },
        expression: "section4.title"
      }
    })], 1), _c('v-col', [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: section4.txt,
        callback: function ($$v) {
          _vm.$set(section4, "txt", $$v);
        },
        expression: "section4.txt"
      }
    })], 1)], 1);
  })], 2)], 1)], 1)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("주요 업무 수행 사례")]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }), _c('v-col'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "elevation": "4"
    },
    on: {
      "click": _vm.setSection5Item
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("항목 추가")], 1), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "red",
      "elevation": "4",
      "outlined": ""
    },
    on: {
      "click": _vm.deleteSection5Item
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-delete-outline")]), _vm._v("항목 삭제")], 1)], 1)], 1), _vm._l(_vm.lawyer.section5, function (section5, index) {
    return _c('div', {
      key: index
    }, [_c('v-divider'), _c('v-card-text', {
      staticClass: "py-0"
    }, [[_c('v-row', {
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: section5.title,
        callback: function ($$v) {
          _vm.$set(section5, "title", $$v);
        },
        expression: "section5.title"
      }
    })], 1), _c('v-col', _vm._l(section5.columns, function (column, index) {
      return _c('v-row', {
        key: index
      }, [_c('v-col', {
        attrs: {
          "cols": "3"
        }
      }, [_c('v-textarea', {
        attrs: {
          "rows": "1",
          "dense": "",
          "outlined": "",
          "hide-details": ""
        },
        model: {
          value: column.title,
          callback: function ($$v) {
            _vm.$set(column, "title", $$v);
          },
          expression: "column.title"
        }
      })], 1), _c('v-col', [_c('v-textarea', {
        attrs: {
          "rows": "1",
          "dense": "",
          "outlined": "",
          "hide-details": ""
        },
        model: {
          value: column.txt,
          callback: function ($$v) {
            _vm.$set(column, "txt", $$v);
          },
          expression: "column.txt"
        }
      })], 1)], 1);
    }), 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-col', [_c('v-btn', {
      attrs: {
        "small": "",
        "color": "primary",
        "elevation": "4"
      },
      on: {
        "click": function ($event) {
          return _vm.setSection5Column(index);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "16"
      }
    }, [_vm._v("mdi-plus")]), _vm._v("행 추가")], 1)], 1), _c('v-col', [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteSection5Column(index);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "16"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("행 삭제")], 1)], 1)], 1)], 1)]], 2)], 1);
  })], 2)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "dark": "",
      "color": "blue darken-2",
      "elevation": "4"
    },
    on: {
      "click": function ($event) {
        return _vm.save();
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("저장")])], 1), _vm.isRoot && !_vm.isCreate ? _c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "dark": "",
      "color": "error",
      "elevation": "4"
    },
    on: {
      "click": function ($event) {
        return _vm.remove();
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("삭제")])], 1) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }